import React from 'react';

import Image from '../../Commons/Image/Image';
import BARRIO_NORTE from '../../../assets/swiss-medical-center/centro_barrio_norte.jpg';

import styles from './SwissMedicalBarrioNorte.module.scss';

const SwissMedicalBarrioNorte = () => {
  return (
    <div className={styles.swiss_medical_barrio_norte}>
      <h3>Barrio Norte</h3>
      <p>
        <strong className={styles.swiss_medical_barrio_norte__redText}>Dirección:</strong> Av.
        Pueyrredón 1441/1443, Capital Federal
      </p>
      <p>
        <strong className={styles.swiss_medical_barrio_norte__redText}>Turnos:</strong>{' '}
        0810-333-8876
      </p>
      <Image
        src={BARRIO_NORTE}
        alt='Barrio Norte imagen'
        title='Swiss Medical Barrio Norte'
        classes={styles.swiss_medical_barrio_norte__image}
      />
      <p>
        Desde su creación, el Swiss Medical Center Barrio Norte ha rediseñado el modelo de atención
        de los Centros Médicos en nuestro país.
      </p>
      <p>
        Integrando planteles médicos de las principales especialidades, en forma continua, con los
        más avanzados equipamientos para diagnóstico y tratamiento hemos logrado una rápida y
        exhaustiva evaluación de nuestros pacientes aún en las patologías más complejas, en
        cualquier momento de cada uno de los días del año.
      </p>
      <p>
        En los consultorios ubicados en Pueyrredón 1441 y 1443, Swiss Medical Center permite la
        atención de consultas de demanda espontánea y programada, reuniendo en un solo lugar todo lo
        que usted necesita para la más completa atención médica.
      </p>
      <p>
        Con el fin de brindar mejores servicios hemos ampliado la estructura con 6 pisos de acceso
        por Av. Santa Fe 2479, edificio que está comunicado con el de Av. Pueyrredón 1441.
      </p>
      <p>
        Para agilizar y mejorar la atención de todos nuestros asociados, el centro dispone de
        equipamiento de alta tecnología: dos ecógrafos, dos equipos de rayos, un resonador magnético
        nuclear y un tomógrafo axial computado de alta tecnología.
      </p>
      <p>
        Hemos destinado al servicio de Pediatría un piso completo, a fin de dar respuesta a las
        necesidades de atención de nuestra población infantil.
      </p>
      <p>
        <strong className={styles.swiss_medical_barrio_norte__redText}>
          Atención de Urgencias y Demanda Espontánea
        </strong>
      </p>
      <p className={styles.swiss_medical_barrio_norte__redText}>
        con Guardias activas durante las 24 horas, los 365 días del año.
      </p>
      <ul>
        <li>
          <strong>Clínica Médica:</strong>Pueyrredón 1441, planta baja y subsuelo
        </li>
        <li>
          <strong>Pediatría:</strong> Santa Fe 2479, 1° piso
        </li>
        <li>
          <strong>Ortopedia y Traumatología: </strong>Pueyrredón 1441, planta baja
        </li>
        <li>
          <strong>Cirugía:</strong>Pueyrredón 1441, subsuelo
        </li>
        <li>
          <strong>Ginecología:</strong>Santa Fe 2479, 2° piso
        </li>
        <li>
          <strong>Otorrinolaringología:</strong>Santa Fe 2479, 2° piso
        </li>
        <li>
          <strong>Oftalmología:</strong>Pueyrredón 1443, 10° piso
        </li>
      </ul>
    </div>
  );
};

export default SwissMedicalBarrioNorte;
